/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const incidentNotificationResponsePageOutputIncidentIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentNotificationResponsePageOutputLatestEnrollmentOneAssignmentGenerationMax = 9007199254740991;

export const incidentNotificationResponsePageOutputLatestEnrollmentOneTeamOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentNotificationResponsePageOutputLatestEnrollmentOneTeamOneNameMax = 500;

export const incidentNotificationResponsePageOutputLatestEnrollmentOneEnrolledAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const incidentNotificationResponsePageOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentNotificationResponsePageOutputItemsItemPolicyIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentNotificationResponsePageOutputItemsItemPolicyNameMax = 500;

export const incidentNotificationResponsePageOutputItemsItemTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentNotificationResponsePageOutputItemsItemTeamNameMax = 500;

export const incidentNotificationResponsePageOutputItemsItemConfiguredStepCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemConfiguredStepCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemCountsRecipientCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemCountsRecipientCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemCountsAcceptedCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemCountsAcceptedCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemCountsDeliveredCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemCountsDeliveredCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemCountsFailedCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemCountsFailedCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemCountsUnknownCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemCountsUnknownCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemAssignmentGenerationMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemOriginalReceiptRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const incidentNotificationResponsePageOutputItemsItemEnrolledAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const incidentNotificationResponsePageOutputItemsItemEnrolledRevisionMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemAppliedRevisionMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemFinishedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const incidentNotificationResponsePageOutputItemsItemNextDueAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneKeyMax = 160;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneStepIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneStepPositionMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneStepPositionMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneStepDelayMinutesMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneStepDelayMinutesMax = 1440;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneStepTargetOneUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneStepTargetTwoScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneStepTargetThreeTeamIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneStepChannelsMax = 3;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneTargetNameMax = 500;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneDueAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneAppliedRevisionMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneReasonsMax = 14;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsRecipientCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsRecipientCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsAcceptedCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsAcceptedCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsDeliveredCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsDeliveredCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsFailedCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsFailedCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsUnknownCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsUnknownCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoKeyMax = 160;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoStepIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoStableStepIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoPositionOneMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoPositionOneMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoDueAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoTargetOneUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoTargetTwoScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoTargetThreeTeamIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoTargetNameMax = 500;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoAuthorizingRevisionMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoAuthorizedAtRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
  );
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoLastObservedAtOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
  );
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoAttemptCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoAttemptCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoReasonsMax = 14;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsRecipientCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsRecipientCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsAcceptedCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsAcceptedCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsDeliveredCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsDeliveredCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsFailedCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsFailedCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsUnknownCountMin = 0;
export const incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsUnknownCountMax = 9007199254740991;

export const incidentNotificationResponsePageOutputItemsItemStepsMax = 100;

export const incidentNotificationResponsePageOutputItemsItemNextCursorOneMax = 2000;

export const incidentNotificationResponsePageOutputItemsMax = 100;

export const incidentNotificationResponsePageOutputNextCursorOneMax = 2000;

export const IncidentNotificationResponsePageOutput = zod.object({
  incidentId: zod.uuid().regex(incidentNotificationResponsePageOutputIncidentIdRegExp),
  incidentStatus: zod.enum(['open', 'acknowledged', 'resolved']),
  latestEnrollment: zod.union([
    zod.object({
      assignmentGeneration: zod
        .int()
        .min(1)
        .max(incidentNotificationResponsePageOutputLatestEnrollmentOneAssignmentGenerationMax),
      team: zod.union([
        zod.object({
          id: zod
            .uuid()
            .regex(incidentNotificationResponsePageOutputLatestEnrollmentOneTeamOneIdRegExp),
          name: zod
            .string()
            .min(1)
            .max(incidentNotificationResponsePageOutputLatestEnrollmentOneTeamOneNameMax),
        }),
        zod.null(),
      ]),
      enrolledAt: zod.iso
        .datetime({ offset: true })
        .regex(incidentNotificationResponsePageOutputLatestEnrollmentOneEnrolledAtRegExp),
      outcome: zod.enum(['no-team', 'no-enabled-policy', 'enrolled']),
    }),
    zod.null(),
  ]),
  items: zod
    .array(
      zod.object({
        id: zod.uuid().regex(incidentNotificationResponsePageOutputItemsItemIdRegExp),
        policy: zod.object({
          id: zod.uuid().regex(incidentNotificationResponsePageOutputItemsItemPolicyIdRegExp),
          name: zod
            .string()
            .min(1)
            .max(incidentNotificationResponsePageOutputItemsItemPolicyNameMax),
        }),
        team: zod.object({
          id: zod.uuid().regex(incidentNotificationResponsePageOutputItemsItemTeamIdRegExp),
          name: zod.string().min(1).max(incidentNotificationResponsePageOutputItemsItemTeamNameMax),
        }),
        configuredStepCount: zod
          .int()
          .min(incidentNotificationResponsePageOutputItemsItemConfiguredStepCountMin)
          .max(incidentNotificationResponsePageOutputItemsItemConfiguredStepCountMax),
        counts: zod.object({
          recipientCount: zod
            .int()
            .min(incidentNotificationResponsePageOutputItemsItemCountsRecipientCountMin)
            .max(incidentNotificationResponsePageOutputItemsItemCountsRecipientCountMax),
          acceptedCount: zod
            .int()
            .min(incidentNotificationResponsePageOutputItemsItemCountsAcceptedCountMin)
            .max(incidentNotificationResponsePageOutputItemsItemCountsAcceptedCountMax),
          deliveredCount: zod
            .int()
            .min(incidentNotificationResponsePageOutputItemsItemCountsDeliveredCountMin)
            .max(incidentNotificationResponsePageOutputItemsItemCountsDeliveredCountMax),
          failedCount: zod
            .int()
            .min(incidentNotificationResponsePageOutputItemsItemCountsFailedCountMin)
            .max(incidentNotificationResponsePageOutputItemsItemCountsFailedCountMax),
          unknownCount: zod
            .int()
            .min(incidentNotificationResponsePageOutputItemsItemCountsUnknownCountMin)
            .max(incidentNotificationResponsePageOutputItemsItemCountsUnknownCountMax),
        }),
        assignmentGeneration: zod
          .int()
          .min(1)
          .max(incidentNotificationResponsePageOutputItemsItemAssignmentGenerationMax),
        originalReceipt: zod.iso
          .datetime({ offset: true })
          .regex(incidentNotificationResponsePageOutputItemsItemOriginalReceiptRegExp),
        enrolledAt: zod.iso
          .datetime({ offset: true })
          .regex(incidentNotificationResponsePageOutputItemsItemEnrolledAtRegExp),
        enrolledRevision: zod
          .int()
          .min(1)
          .max(incidentNotificationResponsePageOutputItemsItemEnrolledRevisionMax),
        appliedRevision: zod
          .int()
          .min(1)
          .max(incidentNotificationResponsePageOutputItemsItemAppliedRevisionMax),
        state: zod.enum(['running', 'stopped', 'superseded', 'finished']),
        outcome: zod.union([
          zod.enum([
            'complete',
            'condition-skipped',
            'edit-skipped',
            'removed',
            'stopped',
            'superseded',
            'no-recipient',
            'unavailable',
            'exhausted',
            'unknown',
          ]),
          zod.null(),
        ]),
        finishedAt: zod.union([
          zod.iso
            .datetime({ offset: true })
            .regex(incidentNotificationResponsePageOutputItemsItemFinishedAtOneRegExp),
          zod.null(),
        ]),
        nextDueAt: zod.union([
          zod.iso
            .datetime({ offset: true })
            .regex(incidentNotificationResponsePageOutputItemsItemNextDueAtOneRegExp),
          zod.null(),
        ]),
        stepsLoaded: zod.boolean(),
        steps: zod
          .array(
            zod.union([
              zod.object({
                kind: zod.literal('configured'),
                key: zod
                  .string()
                  .max(incidentNotificationResponsePageOutputItemsItemStepsItemOneKeyMax),
                id: zod
                  .uuid()
                  .regex(incidentNotificationResponsePageOutputItemsItemStepsItemOneIdRegExp),
                step: zod.object({
                  id: zod
                    .uuid()
                    .regex(incidentNotificationResponsePageOutputItemsItemStepsItemOneStepIdRegExp),
                  position: zod
                    .int()
                    .min(incidentNotificationResponsePageOutputItemsItemStepsItemOneStepPositionMin)
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneStepPositionMax,
                    ),
                  delayMinutes: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneStepDelayMinutesMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneStepDelayMinutesMax,
                    ),
                  condition: zod.enum(['not-acknowledged', 'not-resolved']),
                  target: zod.union([
                    zod.object({
                      kind: zod.literal('user'),
                      userId: zod
                        .uuid()
                        .regex(
                          incidentNotificationResponsePageOutputItemsItemStepsItemOneStepTargetOneUserIdRegExp,
                        ),
                    }),
                    zod.object({
                      kind: zod.literal('schedule'),
                      scheduleId: zod
                        .uuid()
                        .regex(
                          incidentNotificationResponsePageOutputItemsItemStepsItemOneStepTargetTwoScheduleIdRegExp,
                        ),
                    }),
                    zod.object({
                      kind: zod.literal('team'),
                      teamId: zod
                        .uuid()
                        .regex(
                          incidentNotificationResponsePageOutputItemsItemStepsItemOneStepTargetThreeTeamIdRegExp,
                        ),
                    }),
                  ]),
                  channels: zod
                    .array(zod.enum(['email', 'sms', 'voice']))
                    .min(1)
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneStepChannelsMax,
                    ),
                }),
                targetName: zod
                  .string()
                  .min(1)
                  .max(incidentNotificationResponsePageOutputItemsItemStepsItemOneTargetNameMax),
                dueAt: zod.iso
                  .datetime({ offset: true })
                  .regex(incidentNotificationResponsePageOutputItemsItemStepsItemOneDueAtRegExp),
                state: zod.enum(['pending', 'selected', 'handling', 'terminal']),
                appliedRevision: zod
                  .int()
                  .min(1)
                  .max(
                    incidentNotificationResponsePageOutputItemsItemStepsItemOneAppliedRevisionMax,
                  ),
                outcome: zod.union([
                  zod.enum([
                    'complete',
                    'condition-skipped',
                    'edit-skipped',
                    'removed',
                    'stopped',
                    'superseded',
                    'no-recipient',
                    'unavailable',
                    'exhausted',
                    'unknown',
                  ]),
                  zod.null(),
                ]),
                reasons: zod
                  .array(
                    zod.enum([
                      'cancelled',
                      'condition-skipped',
                      'edit-skipped',
                      'unavailable',
                      'uncovered',
                      'empty',
                      'missing-channel',
                      'exhausted',
                      'unknown',
                      'failed',
                      'complete',
                      'superseded',
                      'stopped',
                      'removed',
                    ]),
                  )
                  .max(incidentNotificationResponsePageOutputItemsItemStepsItemOneReasonsMax),
                counts: zod.object({
                  recipientCount: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsRecipientCountMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsRecipientCountMax,
                    ),
                  acceptedCount: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsAcceptedCountMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsAcceptedCountMax,
                    ),
                  deliveredCount: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsDeliveredCountMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsDeliveredCountMax,
                    ),
                  failedCount: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsFailedCountMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsFailedCountMax,
                    ),
                  unknownCount: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsUnknownCountMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemOneCountsUnknownCountMax,
                    ),
                }),
              }),
              zod.object({
                kind: zod.literal('authorized'),
                key: zod
                  .string()
                  .max(incidentNotificationResponsePageOutputItemsItemStepsItemTwoKeyMax),
                stepId: zod
                  .uuid()
                  .regex(incidentNotificationResponsePageOutputItemsItemStepsItemTwoStepIdRegExp),
                stableStepId: zod
                  .uuid()
                  .regex(
                    incidentNotificationResponsePageOutputItemsItemStepsItemTwoStableStepIdRegExp,
                  ),
                position: zod.union([
                  zod
                    .int()
                    .min(incidentNotificationResponsePageOutputItemsItemStepsItemTwoPositionOneMin)
                    .max(incidentNotificationResponsePageOutputItemsItemStepsItemTwoPositionOneMax),
                  zod.null(),
                ]),
                dueAt: zod.union([
                  zod.iso
                    .datetime({ offset: true })
                    .regex(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoDueAtOneRegExp,
                    ),
                  zod.null(),
                ]),
                target: zod.union([
                  zod.object({
                    kind: zod.literal('user'),
                    userId: zod
                      .uuid()
                      .regex(
                        incidentNotificationResponsePageOutputItemsItemStepsItemTwoTargetOneUserIdRegExp,
                      ),
                  }),
                  zod.object({
                    kind: zod.literal('schedule'),
                    scheduleId: zod
                      .uuid()
                      .regex(
                        incidentNotificationResponsePageOutputItemsItemStepsItemTwoTargetTwoScheduleIdRegExp,
                      ),
                  }),
                  zod.object({
                    kind: zod.literal('team'),
                    teamId: zod
                      .uuid()
                      .regex(
                        incidentNotificationResponsePageOutputItemsItemStepsItemTwoTargetThreeTeamIdRegExp,
                      ),
                  }),
                ]),
                targetName: zod
                  .string()
                  .min(1)
                  .max(incidentNotificationResponsePageOutputItemsItemStepsItemTwoTargetNameMax),
                condition: zod.union([zod.enum(['not-acknowledged', 'not-resolved']), zod.null()]),
                authorizingRevision: zod
                  .int()
                  .min(1)
                  .max(
                    incidentNotificationResponsePageOutputItemsItemStepsItemTwoAuthorizingRevisionMax,
                  ),
                channel: zod.enum(['email', 'sms', 'voice']),
                authorizedAt: zod.iso
                  .datetime({ offset: true })
                  .regex(
                    incidentNotificationResponsePageOutputItemsItemStepsItemTwoAuthorizedAtRegExp,
                  ),
                lastObservedAt: zod.union([
                  zod.iso
                    .datetime({ offset: true })
                    .regex(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoLastObservedAtOneRegExp,
                    ),
                  zod.null(),
                ]),
                attemptCount: zod
                  .int()
                  .min(incidentNotificationResponsePageOutputItemsItemStepsItemTwoAttemptCountMin)
                  .max(incidentNotificationResponsePageOutputItemsItemStepsItemTwoAttemptCountMax),
                reasons: zod
                  .array(
                    zod.enum([
                      'cancelled',
                      'condition-skipped',
                      'edit-skipped',
                      'unavailable',
                      'uncovered',
                      'empty',
                      'missing-channel',
                      'exhausted',
                      'unknown',
                      'failed',
                      'complete',
                      'superseded',
                      'stopped',
                      'removed',
                    ]),
                  )
                  .max(incidentNotificationResponsePageOutputItemsItemStepsItemTwoReasonsMax),
                counts: zod.object({
                  recipientCount: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsRecipientCountMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsRecipientCountMax,
                    ),
                  acceptedCount: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsAcceptedCountMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsAcceptedCountMax,
                    ),
                  deliveredCount: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsDeliveredCountMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsDeliveredCountMax,
                    ),
                  failedCount: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsFailedCountMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsFailedCountMax,
                    ),
                  unknownCount: zod
                    .int()
                    .min(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsUnknownCountMin,
                    )
                    .max(
                      incidentNotificationResponsePageOutputItemsItemStepsItemTwoCountsUnknownCountMax,
                    ),
                }),
              }),
            ]),
          )
          .max(incidentNotificationResponsePageOutputItemsItemStepsMax),
        nextCursor: zod.union([
          zod.string().max(incidentNotificationResponsePageOutputItemsItemNextCursorOneMax),
          zod.null(),
        ]),
      }),
    )
    .max(incidentNotificationResponsePageOutputItemsMax),
  nextCursor: zod.union([
    zod.string().max(incidentNotificationResponsePageOutputNextCursorOneMax),
    zod.null(),
  ]),
});

export type IncidentNotificationResponsePageOutput = zod.input<
  typeof IncidentNotificationResponsePageOutput
>;
export type IncidentNotificationResponsePageOutputOutput = zod.output<
  typeof IncidentNotificationResponsePageOutput
>;
